import { render, staticRenderFns } from "./ContratModalEdit.vue?vue&type=template&id=552f6796"
import script from "./ContratModalEdit.vue?vue&type=script&lang=ts"
export * from "./ContratModalEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports